import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  Tooltip,
  IconButton,
  CircularProgress,
} from "@mui/material";
import { DeleteOutline } from "@mui/icons-material";

const getValue = (value) => {
  if (value === null || value === undefined || value === "") return "Not set";
  return String(value);
};

const LabeledValue = ({ label, value }) => (
  <Box sx={{ mb: 1.25 }}>
    <Typography sx={{ fontSize: 13, color: "#6b7280", mb: 0.25 }}>{label}</Typography>
    <Typography sx={{ fontSize: 14, color: "#1f2937", wordBreak: "break-word" }}>
      {getValue(value)}
    </Typography>
  </Box>
);

const ConditionalLogicDetailsDialog = ({
  open,
  onClose,
  step,
  onRemove,
  isRemoving = false,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: { borderRadius: "12px" },
      }}
    >
      <DialogTitle
        sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", pb: 1.25 }}
      >
        <Typography sx={{ fontSize: 16, fontWeight: 600 }}>Conditional Logic</Typography>
        <Tooltip title="Remove Conditional Logic">
          <span>
            <IconButton
              size="small"
              disabled={isRemoving}
              sx={{
                width: 32,
                height: 32,
                borderRadius: "8px",
                color: "#dc2626",
                backgroundColor: "#fef2f2",
                "&:hover": {
                  backgroundColor: "#fee2e2",
                },
              }}
              onClick={onRemove}
            >
              {isRemoving ? <CircularProgress size={16} sx={{ color: "#dc2626" }} /> : <DeleteOutline sx={{ fontSize: 18 }} />}
            </IconButton>
          </span>
        </Tooltip>
      </DialogTitle>

      <DialogContent dividers>
        <LabeledValue label="Logic" value={step?.condLogic} />
        <LabeledValue label="Expression" value={step?.condexp} />
      </DialogContent>

      <DialogActions sx={{ px: 3, py: 2 }}>
        <Button
          variant="contained"
          onClick={onClose}
          sx={{
            background: "#ff5336",
            borderRadius: "8px",
            textTransform: "none",
            fontSize: "14px",
            fontWeight: 600,
            px: 2.5,
            "&:hover": {
              background: "#e94a2f",
            },
          }}
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConditionalLogicDetailsDialog;
